<template>
  <div>
    <el-tag
      v-for="num in [1, 2, 3, 4, 5]"
      :key="num"
      class="pointer"
      :type="round === num ? 'success' : ''"
      size="mini"
      @click.native="turnround(num)"
      >第{{ num }}轮</el-tag
    >
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="table"
      border
      :height="listheight"
      tooltip-eff0-ect="dark"
      size="mini"
      style="width: 100%"
    >
      <el-table-column v-for="head in tableHeads" :key="head" :prop="head" :label="head" width="100">
        <template slot-scope="scope">
          <span v-if="head === '姓名'" class="company-pointer" @click="showRadishDetail(scope.row)">{{
            scope.row.姓名
          }}</span>
          <span v-else>{{ scope.row[head] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    pid: { type: String, default: '' },
  },
  data() {
    return {
      table: [],
      loading: false,
      listheight: '100px',
      tableHeads: ['姓名', '公司', '性别'],
      round: 1,
    }
  },
  watch: {
    pid(newValue, oldValue) {
      if (newValue) this.loadData()
    },
  },
  mounted() {
    this.initHeight()
    if (this.pid) this.loadData()
  },
  methods: {
    turnround(num) {
      this.round = num
      this.loadData()
    },
    getDate(val) {
      const year = new Date(val).getFullYear()
      const month = new Date(val).getMonth() + 1
      const data = new Date(val).getDate()
      return `${year}/${month}/${data}`
    },
    showRadishDetail(opts) {
      if (opts.rid) {
        window.open(`${window.frontend}/#/radish-detail-blank/${opts.rid}`, '_blank')
      }
    },
    async loadData() {
      this.loading = true
      const res = await app.service('company').getInterviewGradeList({ pid: this.pid, round: this.round })
      this.loading = false
      if (res.status === 'success') {
        this.table = res.data
        this.tableHeads = ['姓名', '公司', '性别'].concat(res.projectTags)
      } else {
        this.$message.error(res.msg)
      }
    },
    initHeight() {
      this.$nextTick(() => {
        this.listheight = `${window.innerHeight - 220}px`
      })
    },
  },
}
</script>
<style scoped>
.company-pointer {
  cursor: pointer;
  color: #409eff;
}
.pointer {
  cursor: pointer;
}
</style>
